__webpack_require__.p = "/pinkfreebee/";